import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import { selectSiteUrl } from 'core/selectors/app';

import { fillFeaturedDealsHeading } from '../actions';

import {
  selectFeaturedDealsConfig,
  selectFeaturedDealsHeadingIsLoading,
  selectFeaturedDealsHeadingIsLoaded,
  selectFeaturedDealsHeadingData,
} from '../selectors';

export const useGetHeading = () => {
  const dispatch = useDispatch();
  const config = useSelector(selectFeaturedDealsConfig);
  const isLoading = useSelector(selectFeaturedDealsHeadingIsLoading);
  const isLoaded = useSelector(selectFeaturedDealsHeadingIsLoaded);
  const headingData = useSelector(selectFeaturedDealsHeadingData);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const siteUrl = useSelector(selectSiteUrl);

  const { shouldFetchHeadingFromAPI, getViewAllLinkText, sectionTitle } = config;

  useEffect(() => {
    // use hardcoded non-api-provided heading
    if (!shouldFetchHeadingFromAPI) {
      const viewAllLinkText = getViewAllLinkText(isMobileMQ);
      const clickUrl = `${siteUrl}/sp____.htm`;
      dispatch(fillFeaturedDealsHeading({ viewAllLinkText, sectionTitle, clickUrl }));
      return;
    }

    // use api-provided heading
    if (!isLoaded && !isLoading) {
      const { headingApi: { params, options } } = config;
      dispatch(fetchPlacements(params, options));
    }
  }, [isMobileMQ]);

  return {
    isLoaded,
    isLoading,
    headingData,
  };
};
